<template>
  <v-dialog
    v-model="dialog"
    persistent
    @input="dialogStateChanged"
    transition="dialog-bottom-transition"
    max-width="800px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        small
        color="primary"
        v-bind="attrs"
        v-on="on"
        id="add-decision-action-button"
      >
        <v-icon>mdi-plus-circle</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="pa-4 headline white--text primary">
        New Decision
      </v-card-title>
      <v-card-text class="pa-4 ma-0">
        <div>
          <h2>Name your decision</h2>
        </div>
        <v-text-field
          label="Name*"
          required
          v-model="newDecisionName"
          :error-messages="nameErrors"
          placeholder="Describe what you are deciding"
          @input="$v.newDecisionName.$touch()"
          @blur="$v.newDecisionName.$touch()"
        ></v-text-field>
      </v-card-text>
      <v-card-text class="pa-0">
        <div class="px-4 pt-2">
          <h2>Set the Category</h2>
        </div>
        <v-tabs v-model="currentTab">
          <v-tab @click="currentTab = 0">
            <v-icon left>mdi-playlist-check</v-icon>
            Choose
          </v-tab>
          <v-tab @click="currentTab = 1">
            <v-icon left>mdi-account-details</v-icon>
            Create
          </v-tab>

          <v-tab-item class="pa-4">

                <DecisionCategorySelect
                  v-model="decisionCategory"
                  :breadcrumbItems="categoryBreadcrumb"
                  @breadcrumbs="updateCategoryBreadCrumbs"
                />

          </v-tab-item>

          <v-tab-item class="pa-4">

                <form class="d-md-flex align-center">
                  <v-combobox
                    id="int-tr-trgt-5b"
                    class="mr-2"
                    v-model="customCategoryName"
                    :items="userCategoryNames"
                    label="Name or select your own category"
                    :error-messages="customCategoryErrors"
                    @change="$v.customCategoryName.$touch()"
                    @keydown="$v.customCategoryName.$touch()"
                    @blur="$v.customCategoryName.$touch()"
                  ></v-combobox>
                </form>

          </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false">Cancel</v-btn>
        <v-btn color="primary" :disabled="$v.newDecisionName.$invalid || $v.categoryData.$invalid" @click="handleConfirm">Create</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Constants from '../constants.json'
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'
import axios from 'axios'

// vuelidate
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'

import { mapState } from 'vuex'

// Veux types
import * as DecisionsTypes from '../store/types/decisions'

import DecisionCategorySelect from '@/components/DecisionCategorySelect.vue'

export default {
  name: 'NewDecisionDialog',
  mixins: [validationMixin],
  validations: {
    newDecisionName: { required, maxLength: maxLength(100) },
    customCategoryName: {
      minLength: minLength(3),
      maxLength: maxLength(60)
    },
    categoryData: {
      required
    }
  },
  components: {
    DecisionCategorySelect
  },
  props: {
    defaultName: String
  },
  data () {
    return {
      // dialog: false,
      newDecisionName: null,
      decisionCategory: null,
      categoryBreadcrumb: [],
      customCategoryName: null,
      userCategories: [],
      currentTab: 0
    }
  },
  watch: {
    defaultName: function (value, oldValue) {
      if (value && value !== oldValue) {
        this.newDecisionName = value
      }
    }
  },
  computed: {
    ...mapState({
      dialogState: state => state.decisions.newDialogOpen
    }),
    dialog: {
      // getter
      get: function () {
        return this.dialogState
      },
      // setter
      set: function (newValue) {
        this.$store.commit(`decisions/${DecisionsTypes.MUTATION_NEW_DECISION_DIALOG}`, newValue)
        // this.$emit('onChoose', newValue)
      }
    },
    nameErrors () {
      const errors = []
      if (!this.$v.newDecisionName.$dirty) return errors
      !this.$v.newDecisionName.maxLength && errors.push('The name of the Decision must be at most 100 characters long')
      !this.$v.newDecisionName.required && errors.push('A name for the Decision is required.')
      return errors
    },
    customCategoryErrors () {
      const errors = []
      if (!this.$v.customCategoryName.$dirty) return errors
      !this.$v.customCategoryName.minLength && errors.push('Category name must be at least 3 characters long')
      !this.$v.customCategoryName.maxLength && errors.push('Category name must be at most 60 characters long')
      return errors
    },
    categoryData () {
      let categoryData = null
      if (this.customCategoryName) {
        categoryData = {
          category: {
            id: '',
            name: this.customCategoryName,
            userDefined: true
          }
        }
      } else if (this.decisionCategory) {
        const latestBreadcrumbTrail = []
        if (this.categoryBreadcrumb) {
          this.categoryBreadcrumb.forEach(item => {
            latestBreadcrumbTrail.push({id: item.id, name: item.name})
          })
        }

        const currentCategory = this.decisionCategory ? {
          id: this.decisionCategory.id,
          name: this.decisionCategory.name
        } : null

        categoryData = {
          category: currentCategory,
          categoryBreadcrumb: latestBreadcrumbTrail
        }
      }

      return categoryData
    },
    userCategoryNames () {
      return this.userCategories.map(cat => cat.name)
    },
  },
  methods: {
    handleConfirm: function () {
      this.dialog = false
      const newDecisionData = {name: this.newDecisionName, categoryData: this.categoryData}
      this.$emit('onConfirm', newDecisionData)
    },
    dialogStateChanged: function () {
      this.currentTab = 0
      this.newDecisionName = null
      this.decisionCategory = null
      this.categoryBreadcrumb = []
      this.customCategoryName = null
      // this.newDecisionName = this.defaultName
      this.$v.$reset()

      this.loadUserCategories()
    },
    updateCategoryBreadCrumbs: function (newList) {
      this.categoryBreadcrumb = newList
    },
    loadUserCategories: async function () {
      this.userCategories = []
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const fetchURL = `${Constants.API_BASE_PATH}/uesrcategories`
      const res = await axios.get(fetchURL, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })

      if (res.data && res.data.status === 'success') {
        this.userCategories = res.data.categories
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
